import { ClientChangeInfo } from "./ClientChangeInfo";
import { useChangeHistoryScope } from "./hooks/useChangeHistoryScope";

/**
 * The change-info line of the current page, whose scope the route says. Split off from
 * {@link ClientChangeInfo} so that only a page's line subscribes to the route: a dialog names the
 * record it has open, and would otherwise re-render on every search-param change of the page behind
 * it to resolve a scope it never uses.
 */
export function ClientRouteChangeInfo() {
  const scope = useChangeHistoryScope();

  return <ClientChangeInfo scope={scope} />;
}
